import { redirect, LoaderFunction, LoaderFunctionArgs } from 'react-router-dom'
import { useSessionStore } from '@/stores'
import { portalRedirectFor } from './portalRegistry'

const requireValidSession = (request: Request): void => {
  if (useSessionStore.getState().isSessionValid()) {
    return
  }
  const url = new URL(request.url)
  const redirectUrl = new URL('/', url.origin)
  redirectUrl.searchParams.set('redirect', url.pathname + url.search)
  throw redirect(redirectUrl.toString())
}

export const enforcePortalBoundary = (request: Request): void => {
  const { session, campaign } = useSessionStore.getState()
  const url = new URL(request.url)

  // The embed keys its localStorage off this param; diverting would lose the session.
  if (url.searchParams.get('is_chatbot_embed') === 'true') {
    return
  }

  const target = portalRedirectFor(url.pathname, session, campaign)
  if (target && target !== url.pathname) {
    throw redirect(`${target}${url.search}`)
  }
}

export const requireSessionLoader: LoaderFunction = async ({ request }: LoaderFunctionArgs) => {
  requireValidSession(request)
  enforcePortalBoundary(request)
  return null
}

// No boundary: /undo runs on popstate, where a divert would swallow the undo call.
export const undoRouteLoader: LoaderFunction = async ({ request }: LoaderFunctionArgs) => {
  requireValidSession(request)
  return null
}

// Home guard — no redirect, HomePage handles all session start logic
export const homeGuardLoader: LoaderFunction = async () => {
  return null
}

export const chatbotGuardLoader: LoaderFunction = async () => {
  const sessionStore = useSessionStore.getState()

  if (!sessionStore.isSessionValid() || !(sessionStore.session as any)?.show_chatbot) {
    throw redirect('/')
  }

  return null
}

export const faqGuardLoader: LoaderFunction = async () => {
  const sessionStore = useSessionStore.getState()

  if (!sessionStore.isSessionValid() || !(sessionStore.session as any)?.show_faqs) {
    throw redirect('/')
  }

  return null
}

// For /step/:step — redirect to /start/:step if no valid session (to start and jump)
export const stepJumpLoader: LoaderFunction = async ({ params }: LoaderFunctionArgs) => {
  const sessionStore = useSessionStore.getState()

  if (!sessionStore.isSessionValid()) {
    throw redirect(`/start/${params.step}`)
  }

  return null
}
